import React from 'react';

export default function SpanHeader({ record }) {
  const headingClass = record.htype.split("h")[1];
  return (
    <>
      {React.createElement(
        record.htype, // Dynamically set the tag type
        {
          id: record.spanid,
          className: `heading-${headingClass} mt-6`
        },
        record.span // The content of the heading
      )}
    </>
  );
}